/**
 * Копия apps/website/public/brand/aelo-lockup.svg с явными атрибутами вместо
 * классов .nm/.by/.pr: их стили живут в apps/website/src/layouts/Base.astro,
 * поэтому скопированный «как есть» логотип отрендерился бы дефолтным шрифтом.
 * Инлайн — чтобы при печати не было ни одного внешнего запроса за картинкой.
 */
export const AELO_LOCKUP_SVG = `<svg viewBox="0 0 320 56" width="150" height="26" role="img" aria-label="Aelo · by Grow2.ai">
  <rect x="2" y="6" width="44" height="44" rx="10" fill="#ffffff" stroke="#111311" stroke-width="2"/>
  <circle cx="24" cy="28" r="13" fill="none" stroke="#3a9995" stroke-width="1.5"/>
  <circle cx="24" cy="28" r="3.5" fill="#3a9995"/>
  <text x="60" y="37" font-family="Space Grotesk, Georgia, serif" font-size="26" font-weight="700" fill="#111311">Aelo</text>
  <line x1="136" y1="14" x2="136" y2="42" stroke="#d9d5c7" stroke-width="1"/>
  <text x="148" y="26" font-family="JetBrains Mono, monospace" font-size="11" font-weight="500" fill="#6b7280" letter-spacing="1">by</text>
  <text x="148" y="43" font-family="JetBrains Mono, monospace" font-size="13" font-weight="600" fill="#3a9995">Grow2.ai</text>
</svg>`;
